import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";

const PARAS = [
  "Fuel Hauler Pro is a free tank stick calculator and drop planner for fuel haulers, tanker drivers and station crews. Type a stick reading and it shows the gallons in the tank and the room left to 90%, using a chart for the tank's size and shape.",
  "Before you unload, Plan a drop shows where the stick will land and warns you at 90%, past 95% and before a spill. It can also read a console printout or BOL from a photo, flag water and wrong-product drops, and check your truck's weight.",
  "It's built by a working fuel hauler and runs in any phone browser. The numbers are estimates, so always confirm them with the station's chart, the console and your own stick.",
];

export function HomeIntro() {
  const t = useT();
  return (
    <section className="home-intro" data-testid="home-intro">
      <h2 className="home-intro-title">{t("What is Fuel Hauler Pro?")}</h2>
      {PARAS.map((p) => <p key={p} className="welcome-sub">{t(p)}</p>)}
      <div className="welcome-links">
        <Link to="/guide" data-testid="home-guide-link">{t("How-to guide")}</Link>
        <Link to="/faq" data-testid="home-faq-link">{t("FAQ")}</Link>
      </div>
    </section>
  );
}
